<div class="profile-pref-container">
  <div class="row profile-ref-tabs-row">
    <div class="col-12 profile-title-row">
      <span class="profile-preference-title">Profile</span>
      <div
        class=""
        *ngIf="showBackButton"
      >
        <ces-button
          label="Back To Apps"
          [ghost]="true"
          ghostType="secondary"
          size="medium"
          icon="icon-chevron-left"
          iconPosition="left"
          (onClick)="backToApp()"
        >
        </ces-button>
      </div>
    </div>
  </div>

  <ng-container>
    <div class="row basic-info-row">
      <div class="col-12 col-sm-6 col-lg-4 col-md-4 col-xl-3 info-block">
        <div class="profile-img-name-bloack">
          <div class="profile-img">
            <ces-avatar
              [imageUrl]="profileImageUrl"
              customClass="profile-avatar"
            ></ces-avatar>
          </div>
          <div class="profile-name">
            <div class="info-label">
              {{ currentUserData?.nickname ? currentUserData.nickname : '-' }}
            </div>
            <div class="info-value">{{ organizationName }}</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-4 col-md-4 col-xl-3 info-block">
        <div class="info-label">Email</div>
        <div class="info-value">{{ currentUserData?.email ? currentUserData.email : '-' }}</div>
      </div>
      <div class="col-12 col-sm-6 col-lg-4 col-md-4 col-xl-3 info-block">
        <div class="info-label">User Status</div>
        <div class="info-value">{{ currentUserData?.blocked ? 'In-Active' : 'Active' }}</div>
      </div>
      <div class="col-12 col-sm-6 col-lg-4 col-md-4 col-xl-3 info-block">
        <div class="info-label">Logins Count</div>
        <div class="info-value">
          {{ currentUserData?.logins_count ? currentUserData?.logins_count : '-' }}
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-4 col-md-4 col-xl-3 info-block">
        <div class="info-label">Signed Up</div>
        <div class="info-value">{{ signedUpDate ? signedUpDate : '-' }}</div>
      </div>
      <div class="col-12 col-sm-6 col-lg-4 col-md-4 col-xl-3 info-block">
        <div class="info-label">Latest Login</div>
        <div class="info-value">{{ latestLogin ? latestLogin : '-' }}</div>
      </div>

      <div class="col-12 col-sm-6 col-lg-4 col-md-4 col-xl-3 info-block">
        <div class="info-label">Application Associated</div>
        <div class="info-value">{{ appAssociated ? appAssociated : 'N/A' }}</div>
      </div>
      <div
        class="col-12 col-sm-6 col-lg-4 col-md-4 col-xl-3 info-block"
        *ngIf="showChangePassword"
      >
        <div
          class="info-label change-pwd-label"
          (click)="changePasswordModal()"
        >
          Change Password
        </div>
      </div>
    </div>
  </ng-container>
  <div
    class="widget-loader"
    *ngIf="loader"
  >
    <ces-loaders
      type="spinner"
      size="medium"
      textPosition="center"
    ></ces-loaders>
  </div>
  <div #container></div>
</div>
